export default __webpack_public_path__ + "static/media/limiteRetiroAlcanzado.03dcab49.svg";